<div class="app-job-schedule"
     data-testid="cm-job-schedule">
  <div class="job-container"
       data-testid="cm-container-job">
    <div class="title-header"
         data-testid="cm-header-title">
      <div class="title-header-main">
        <p class="header-lg-bold"
           data-testid="cm-text-title">{{title}}</p>
        <online-indicator data-testid="cm-header-online"></online-indicator>
      </div>
      <app-background-refresh-indicator [active]="isRefreshingInBackground()" />

      <div class="schedule-tabs-row">
        <p-tabs [value]="activeTab()"
                (valueChange)="setActiveTab($any($event))"
                [showNavigators]="false"
                class="schedule-tabs"
                data-testid="schedule-tabs">
          <p-tablist>
            <p-tab [value]="ScheduleTabEnum.ThisWeek"
                   data-testid="cm-tab-this-week">This Week</p-tab>
            <p-tab [value]="ScheduleTabEnum.LastWeek"
                   data-testid="cm-tab-last-week">Last Week ({{ lastWeekCards().length }})</p-tab>
          </p-tablist>
        </p-tabs>

        <!-- Sits in the tab strip's gutter, so it is positioned over p-tablist rather than inside it. -->
        <button type="button"
                class="schedule-filter-btn"
                [class.schedule-filter-btn--active]="appliedFilterCount() > 0"
                (click)="openFilterSheet()"
                data-testid="cm-button-filter"
                [attr.aria-label]="appliedFilterCount() > 0
                  ? 'Filter and sort schedule (' + appliedFilterCount() + ' applied)'
                  : 'Filter and sort schedule'">
          <i [class]="appliedFilterCount() > 0 ? 'pi pi-filter-fill' : 'pi pi-filter'"
             aria-hidden="true"></i>
          @if (appliedFilterCount() > 0) {
            <span class="schedule-filter-count"
                  data-testid="cm-badge-filter-count">{{ appliedFilterCount() }}</span>
          }
        </button>
      </div>
    </div>

    <!-- Outside the tab switch so an applied filter stays visible on whichever tab the CM lands on. -->
    <div class="filter-chip-row"
         (wheel)="onChipRowWheel($event)"
         data-testid="cm-container-filter-chips">
      @for (chip of appliedFilterChips(); track chip.filterId + chip.value) {
        <p-chip [label]="chip.displayLabel"
                [removable]="chip.removable"
                removeIcon="pi pi-times"
                styleClass="schedule-filter-chip"
                (onRemove)="removeFilterChip(chip)" />
      }
    </div>

    <div class="job-schedule"
         data-testid="cm-list-schedule">
      @if (dataLoaded) {
        <div class="schedule-body"
             [appDataUpdatedFade]="dataUpdatedPulse()">

          @if (isCurrentTabFilteredEmpty()) {
            <div class="schedule-empty schedule-empty--page"
                 data-testid="cm-container-no-filter-matches">
              <span class="schedule-empty-text">No lots match this filter</span>
            </div>
          } @else if (activeTab() === ScheduleTabEnum.ThisWeek) {
            @if (thisWeekTabCardCount() === 0) {
              <div class="schedule-empty schedule-empty--page"
                   data-testid="cm-container-nothing-scheduled">
                <span class="schedule-empty-text">Nothing scheduled</span>
              </div>
            } @else {
              @if (overdueCards().length > 0) {
                <div class="schedule-section"
                     data-testid="cm-container-overdue">
                  @for (card of overdueCards(); track card.lotId) {
                    <app-schedule-lot-card [card]="card"
                                           [syncStatusOf]="syncStatusOf"
                                           [lotPrimaryIdentifier]="lotPrimaryIdentifier()"
                                           [showDate]="true"
                                           (cardClick)="viewLotSummary($event)"
                                           (syncStatusClick)="viewJobSyncStatus($event)" />
                  }
                </div>
              }

              @for (section of scheduleSections(); track section.key) {
                <div class="schedule-section"
                     [attr.data-testid]="'cm-container-section-' + section.key">
                  <div class="schedule-section-header">
                    <span class="schedule-section-label">{{ section.label }}</span>
                    <span class="schedule-section-date">{{ section.dateLabel }}</span>
                  </div>

                  @if (section.cards.length > 0) {
                    @for (card of section.cards; track card.lotId) {
                      <app-schedule-lot-card [card]="card"
                                             [syncStatusOf]="syncStatusOf"
                                             [lotPrimaryIdentifier]="lotPrimaryIdentifier()"
                                             [showDate]="section.showCardDates"
                                             (cardClick)="viewLotSummary($event)"
                                             (syncStatusClick)="viewJobSyncStatus($event)" />
                    }
                  } @else {
                    <div class="schedule-empty"
                         [attr.data-testid]="'cm-container-empty-' + section.key">
                      <span class="schedule-empty-text">Nothing scheduled</span>
                    </div>
                  }
                </div>
              }
            }
          } @else {
            <div class="schedule-section"
                 data-testid="cm-container-last-week">
              @if (lastWeekCards().length > 0) {
                @for (card of lastWeekCards(); track card.lotId) {
                  <app-schedule-lot-card [card]="card"
                                         [syncStatusOf]="syncStatusOf"
                                         [lotPrimaryIdentifier]="lotPrimaryIdentifier()"
                                         [showDate]="true"
                                         (cardClick)="viewLotSummary($event)"
                                         (syncStatusClick)="viewJobSyncStatus($event)" />
                }
              } @else {
                <div class="schedule-empty schedule-empty--page"
                     data-testid="cm-container-all-caught-up">
                  <span class="schedule-empty-text">All caught up</span>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <div class="schedule-body"
             data-testid="cm-container-skeleton">
          <div class="skeleton-container">
            <app-job-skeleton [isCMView]="true"></app-job-skeleton>
            <app-job-skeleton [isCMView]="true"></app-job-skeleton>
            <app-job-skeleton [isCMView]="true"></app-job-skeleton>
            <app-job-skeleton [isCMView]="true"></app-job-skeleton>
          </div>
        </div>
      }

      <app-support-footer></app-support-footer>
    </div>
  </div>

  <app-bottom-sheet [(isOpen)]="isBottomSheetOpen"
                    [contentTemplate]="jobSyncStatusTemplate"
                    [preventOverlayClose]="false"
                    [hasFooter]="false"
                    [isFullScreen]="false" />

  <app-schedule-filter-panel [(isOpen)]="isFilterSheetOpen"
                             [cards]="filterableCards()"
                             [lotPrimaryIdentifier]="lotPrimaryIdentifier()" />
</div>

<ng-template #jobSyncStatusTemplate>
  <job-sync-status-drawer [jobId]="selectedJob ? selectedJob.id : null"
                          [jobMetadata]="selectedJob ? syncMetadata[selectedJob.id] : null"
                          [jobStatus]="selectedJob ? syncStatus(selectedJob) : null"
                          [overdueJobRoute]="selectedJob ? getOverdueJobRoute(selectedJob) : null"
                          [jobActionName]="'Step'"
                          (onSyncSheetClose)="onSyncSheetClose()" />
</ng-template>